module.exports = __webpack_public_path__ + "static/media/img-02.b211cb6b.jpg";